import React, { useState, useEffect } from "react"
import { makeStyles } from "@material-ui/core/styles"
import Stepper from "@material-ui/core/Stepper"
import Step from "@material-ui/core/Step"
import StepLabel from "@material-ui/core/StepLabel"
import Typography from "@material-ui/core/Typography"
import { Grid } from "@material-ui/core"
import RegisterCard from "../Card/RegisterCard"
import TerminsCard from "../Card/conditionsCard"
import Finish from "../Card/ConfirmationCard"
import Pago from "../Card/PaymentCard"
import UseApi from "../../hooks/useApi"
import Modal from "../Modal"
import NumberFormat from "react-number-format"

import {
  SEND_INSERT_COMPANY,
  SEND_ACEPT_CONTRACT,
  SEND_PAYMENT,
} from "../../constants/endpoints"
import Progress from "../../components/Progress"
import {setCompany} from "../../utils/LocalStorage"

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    overflowX: "hidden",
  },
  instructions: {
    width: "100%",
  },
  TituloDialog: {
    color: "#003CAE",
    marginTop: "-2rem",
    font: "800 42px/42px Montserrat",
    "@media (max-width: 720px)": {
      width: "90%",
      font: "800 25px/30px Montserrat",
    },
    "@media (max-width: 320px)": {
      width: "80%",
      font: "800 25px/30px Montserrat",
    },
  },
  Subtitulo: {
    color: "#385099",
    font: "400 20px/30px Montserrat",
    "@media (max-width: 720px)": {
      width: "90%",
      font: "400 15px/20px Montserrat",
      marginTop: "1rem",
    },
    "@media (max-width: 320px)": {
      width: "80%",
    },
  },
  TipoVenta: {
    color: "#FFB91C",
    font: "800 34px/42px Montserrat",
    textTransform: "uppercase",
    "@media (max-width: 720px)": {
      font: "800 25px/30px Montserrat",
    },
  },
  stepper: {
    "@media (max-width: 320px)": {
      marginLeft: "-1rem",
    },
  },
}))

function getSteps() {
  return ["Registro", "Términos y condiciones", "Forma de pago", "Finalizar"]
}

export default function HorizontalLabelPositionBelowStepper(props) {
  const { Nempleados, price } = props
  const classes = useStyles()
  const [activeStep, setActiveStep] = React.useState(0)
  const steps = getSteps()
  const { response, errorApi, post } = UseApi()
  const [showProgress, setShowProgress] = useState(false)
  const [idCompanyRegister, setIdCompanyRegister] = useState("")
  const [openModal, setOpenModal] = useState(false)
  const [MessageModal, setMessageModal] = useState("")
  const [titleModal, setTitleModal] = useState("")

  const updateData = (setValue, value) => {
    setValue(value)
  }

  useEffect(() => {
    setShowProgress(false)
    console.log("errorApi")
  }, [errorApi])

  useEffect(() => {
    setShowProgress(false)
    const { headerResponse } = response
    if (response.payload) {
      if (response.payload.datosEmpresa) {
        setIdCompanyRegister(response.payload.datosEmpresa.idEmpresa)
        setCompany(response.payload.datosEmpresa)
        handleNext()
      }
      if (headerResponse.code !== 200) {
        setTitleModal("Se produjo un error")
        setMessageModal(headerResponse.message)
        setOpenModal(true)
      }
    }
  }, [response])

  const registerCompany = async companyData => {
    const query = {
      endpoint: SEND_INSERT_COMPANY,
      data: companyData,
    }
    setShowProgress(true)
    await post(query)
    // handleNext()
  }

  const aceptTerms = async () => {
    const query = {
      endpoint: SEND_ACEPT_CONTRACT,
      data: { idEmpresa: idCompanyRegister },
    }
    setShowProgress(true)
    await post(query)
    // handleNext()
  }

  const handlePayment = async orderId => {
    const query = {
      endpoint: SEND_PAYMENT,
      data: { idEmpresa: idCompanyRegister, idPago: orderId },
    }
    setShowProgress(true)
    await post(query)
  }
  const handleClose = () => {
    setOpenModal(false)
  }

  function getStepContent(stepIndex) {
    switch (stepIndex) {
      case 0:
        return (
          <RegisterCard
            ChangePage={handleNext}
            updateData={updateData}
            employees={Nempleados}
            price={price}
            registerCompany={registerCompany}
          />
        )
      case 1:
        return (
          <TerminsCard ChangePage={handleNext} aceptContract={aceptTerms} />
        )
      case 2:
        return (
          <Pago
            ChangePage={handleNext}
            handlePayment={handlePayment}
            price={price}
          />
        )
      default:
        return <Finish ChangePage={handleNext} />
    }
  }

  const handleNext = () => {
    setActiveStep(prevActiveStep => prevActiveStep + 1)
  }

  return (
    <div className={classes.root}>
      <Progress show={showProgress}></Progress>
      <Grid
        container
        direction="row"
        justify="flex-start"
        alignItems="center"
        xs={12}
        style={{ marginLeft: "2rem", marginTop: "2rem" }}
      >
        {activeStep === 0 ? (
          <div>
            <Typography className={classes.TituloDialog}>
              Vamos a procesar tu paquete:{" "}
              <spam className={classes.TipoVenta}> {props.Tipo} </spam>
            </Typography>
            <Typography className={classes.Subtitulo}>
              1. Empecemos por registrar tus datos:
            </Typography>
          </div>
        ) : activeStep === 1 ? (
          <div>
            <Typography className={classes.TituloDialog}>
              Términos y condiciones
            </Typography>
            <Typography className={classes.Subtitulo}>
              2. Lee detenidamente y acepta los términos y condiciones.
            </Typography>
          </div>
        ) : activeStep === 2 ? (
          <div>
            <Typography className={classes.TituloDialog}>
              Forma de Pago
            </Typography>
            <Typography className={classes.Subtitulo}>
              3. Por favor inicia sesión con tu cuenta de PayPal para proceder
              con el pago.
            </Typography>
          </div>
        ) : activeStep === 3 ? (
          <div>
            <Typography className={classes.TituloDialog}>
              ¡Gracias por tu compra!
            </Typography>
            <Typography className={classes.Subtitulo}>&nbsp;</Typography>
          </div>
        ) : (
          <h1>Fin</h1>
        )}
      </Grid>
      <Stepper
        activeStep={activeStep}
        alternativeLabel
        className={classes.stepper}
      >
        {steps.map(label => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <div>
        {activeStep === steps.length ? (
          <div>
            <Typography className={classes.instructions}>
              {props.close(false)}
            </Typography>
          </div>
        ) : (
          <div>
            <Typography className={classes.instructions}>
              {getStepContent(activeStep)}
            </Typography>
          </div>
        )}
      </div>
      <Modal
        title={titleModal}
        message={MessageModal}
        open={openModal}
        setOpen={setOpenModal}
      />
    </div>
  )
}
